import { createContext, useContext, useState, ReactNode } from "react";
// import { User, Session } from "@supabase/supabase-js"; // BACKEND DISABLED
// import { supabase } from "@/integrations/supabase/client"; // BACKEND DISABLED
import { useNavigate } from "react-router-dom";

// Mock types for when backend is disabled
type User = { id: string; email: string } | null;
type Session = { user: User } | null;

interface AuthContextType {
  user: User;
  session: Session;
  isAdmin: boolean;
  isChiefAdmin: boolean;
  isLoading: boolean;
  adminChecked: boolean;
  signIn: (email: string, password: string) => Promise<{ error: Error | null }>;
  signUp: (email: string, password: string, firstName: string, lastName: string) => Promise<{ error: Error | null }>;
  signOut: () => Promise<void>;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export function AuthProvider({ children }: { children: ReactNode }) {
  // BACKEND DISABLED - All auth state is mocked/disabled
  const [user] = useState<User>(null);
  const [session] = useState<Session>(null);
  const [isAdmin] = useState(false);
  const [isChiefAdmin] = useState(false);
  const [isLoading] = useState(false);
  const [adminChecked] = useState(true);
  const navigate = useNavigate();

  // BACKEND DISABLED - Auth functions are no-ops
  const signIn = async (_email: string, _password: string) => {
    console.log('[Auth] Backend disabled - sign in not available');
    return { error: new Error('Backend is currently disabled') };
  };

  const signUp = async (_email: string, _password: string, _firstName: string, _lastName: string) => {
    console.log('[Auth] Backend disabled - sign up not available');
    return { error: new Error('Backend is currently disabled') };
  };

  const signOut = async () => {
    console.log('[Auth] Backend disabled - sign out not available');
    navigate("/");
  };

  return (
    <AuthContext.Provider value={{ user, session, isAdmin, isChiefAdmin, isLoading, adminChecked, signIn, signUp, signOut }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
}
